import { Icon, Circle } from '@chakra-ui/react';

import { IoArrowUp } from 'react-icons/io5';

// GO TOP 按鈕：回到最上頁
export default function GoTopButton({ onClick }: { onClick?: () => void }) {
  const handleGoTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    onClick && onClick();
  };

  return (
    <Circle
      pos={{ base: 'relative', md: 'relative' }}
      bottom={0}
      bg="primary"
      opacity={0.5}
      p={2}
      as="button"
      onClick={handleGoTop}
    >
      <Icon boxSize="1.5rem" as={IoArrowUp} color="white" />
    </Circle>
  );
}
